import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const Campaigns = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const campaignsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/campaigns',
    name: 'campaigns',
    component: Campaigns,
    meta: {
      title: 'Campañas',
      auth: {
        roles: Object.values(authRoles),
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
